import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import './Footer.css'
import { Conditionnal } from '../ImportAll'
import { step } from '../../engine/StepDefinition'

class Footer extends Component {
    render() {
        var afficherGoHome = <div className="gohome regular-font"></div>
        if (this.props.view && this.props.view !== 0) {
            afficherGoHome = (
                <div className="gohome regular-font">
                    <a
                        href="#"
                        onClick={() =>
                            history.push('/tunnelmobile/', { targetView: 0 })
                        }
                    >
                        Retour à l’accueil
                    </a>
                </div>
            )
        }
        return (
            <div className="Footer regular-font">
                <Conditionnal
                    linked_data_id="tech_device_size"
                    isEqualTo
                    targetDataValueCompare="DESKTOP"
                >
                    <img
                        src="svg/Fill_1.svg"
                        className="svg_footer fill1"
                        alt="maison"
                    />
                    <img
                        src="svg/Fill_2.svg"
                        className="svg_footer fill2"
                        alt="maison"
                    />
                    <img
                        src="svg/Fill_2.svg"
                        className="svg_footer fill3"
                        alt="maison"
                    />
                    <img
                        src="svg/balance_full.svg"
                        className="svg_footer balance"
                        alt="maison"
                    />
                    <img
                        src="svg/nego.svg"
                        className="svg_footer nego"
                        alt="maison"
                    />
                </Conditionnal>
                <div className="textinfo regular-font">
                    Un crédit vous engage et doit être remboursé.
                    <br />
                    Vérifiez vos capacités de remboursement avant de vous
                    engager.
                    <Conditionnal linked_data_id="tech_debug_mode" isNotEmpty>
                        <span className="localisation_indicator">
                            Debug : Vue {step[this.props.view].id_text} (
                            {step[this.props.view].description})
                        </span>
                    </Conditionnal>
                </div>

                <div className="textinfo regular-font">
                    Monemprunt.com - Bâtiment Equinoxe
                    <br />
                    1 rue Robert Duvivier 35000 Rennes<br />
                    Orias N° 16004773 et N° Siret : 82120708100034 <br />
                    <a
                        target="_blank"
                        href="https://www.immodvisor.com/pro/monempruntcom-rennes-35760-22278.html"
                    >
                        Lire nos avis
                    </a>
                </div>

                {afficherGoHome}
                <a
                    href="#"
                    className="ot-sdk-show-settings textinfo regular-font"
                >
                    Cookie Settings
                </a>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        view: state.view,
    }
}

export default connect(mapStateToProps)(Footer)
